import React from "react";
import { Modal } from "react-bootstrap";
import { ApplicationState } from "../../../../../../store";
import { bindActionCreators, Dispatch } from "redux";
import { connect } from "react-redux";
import { hideConfirmSecondaryGoalCreateModal } from "../../../../../../store/onboarding/actions";
import { activeTabUrl, showInterventionPlanModal } from "../../../../../../store/onboarding/cases/actions";
import { InterventionGroup } from "../../../../../../store/onboarding/cases/types";
import { markAddSecondaryGoalAsShown } from "../../../../../../store/tour/actions";

type PropsFromState = {
  showModal: boolean;
  finishedInterventionGroup?: InterventionGroup;
};

type State = { 
  isDeclineToAddSecondaryGoal: boolean;
};

type DispatchProps = {
  hideConfirmSecondaryGoalCreateModal: () => any;
  showInterventionPlanModal: (finishedInterventionGroup: InterventionGroup) => any;
  markAddSecondaryGoalAsShown: (isShown?: boolean) => any;
};

type Props = PropsFromState & DispatchProps;


class ConfirmSecondaryGoalCreateModal extends React.Component<Props, State> {
  constructor(props:Props) {
    super(props);
  }

  state: State = {
    isDeclineToAddSecondaryGoal: false
  }
  
  handleYes = () => {

    this.props.showInterventionPlanModal(this.props.finishedInterventionGroup!);
    //this.props.markAddSecondaryGoalAsShown(true);
    setTimeout(() => {
      document.getElementById('group-workspace-tabs-tab-manage')?.click()
    }, 100);
    setTimeout(() => {
      this.props.markAddSecondaryGoalAsShown(true)
    }, 150);
    this.props.hideConfirmSecondaryGoalCreateModal();
  };

  render() {
    const { showModal } = this.props;
    return (
      <Modal
        show={showModal}
        className="secondaryGoalCreateModal"
        onHide={this.props.hideConfirmSecondaryGoalCreateModal}
        animation={false}
        backdropClassName="customDarkModalBackdrop in"
        centered
        >
        <Modal.Header
          className={`purpleModalHeader font-weight-bold justify-content-center`}
          closeButton
        >
          <Modal.Title>Add Secondary Goals</Modal.Title>
        </Modal.Header>
        <Modal.Body>
            <div className="text-center mb-3">
              <p className="font-weight-bold">Would you like to add one or more secondary goals now?</p>
              <p>You can also add them later by going to the <strong>Manage</strong> tab in the group workspace and clicking the + icon under <strong>Action</strong>. </p>
            </div>
            <hr/>
            <div className="btnActions">
              <button
                className="whiteBtnSm mr-3"
                onClick={() => this.setState({
                isDeclineToAddSecondaryGoal: false
              }, () => this.props.hideConfirmSecondaryGoalCreateModal())}
              >
                Add Later
              </button>
              <button className="blueBtnSm"  onClick={() => this.handleYes()}>
                Add Now
              </button>
            </div>
        </Modal.Body>
      </Modal>
    );
  }
}

const mapStateToProps = ({ onboarding }: ApplicationState): PropsFromState => {
  return {
    showModal: onboarding.modalsState.confirmSecondaryGoalCreateModal,
    finishedInterventionGroup: onboarding.finishedInterventionGroup,
  };
};

const mapDispatchToProps = (dispatch: Dispatch): DispatchProps =>
  bindActionCreators(
    {
      hideConfirmSecondaryGoalCreateModal: hideConfirmSecondaryGoalCreateModal,
      showInterventionPlanModal: showInterventionPlanModal,
      markAddSecondaryGoalAsShown: markAddSecondaryGoalAsShown
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ConfirmSecondaryGoalCreateModal);
